import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14289d61"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "firmware-page" }
const _hoisted_2 = { class: "ws_common_operation ws_pt10 ws_pb24" }

import { ref, onMounted } from 'vue'
import { queryFirmwarePage, deleteFirmwareInfo } from '@/api'
import { CODE_ENUM, PAGE_SIZES } from '@/common'
import OperationButtonList from '@/components/operation-button-list'
import { msgbox } from '@/utils'
import { ElMessage } from 'element-plus'
import FirmwareForm from './components/firmware-form.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const buttonList = [
  {
    type: 'delete',
    text: '删除',
  },
]

const col: any = ref([
  {
    prop: 'productName',
    label: '产品名称',
  },
  {
    prop: 'productModel',
    label: '硬件代码',
  },
  {
    prop: 'chipType',
    label: '芯片类型',
  },
  {
    prop: 'firmwareVersion',
    label: '固件版本',
  },
  {
    prop: 'firmwareName',
    label: '文件名称',
  },
])

const tableData: any = ref([])
const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)
const handleSizeChange = (pageSize: number) => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = (pageSize: number) => {
  fetchList()
}

const tableLoading = ref(false)
const fetchList = async (queryData?: any) => {
  tableLoading.value = true

  const res: any = await queryFirmwarePage({
    ...pageParams.value,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}

onMounted(() => {
  fetchList()
})

const firmwareConf = ref({
  visible: false,
  data: {},
})

const handleForm = (data?: any) => {
  firmwareConf.value = {
    visible: true,
    data,
  }
}

const handleDelete = (data: any) => {
  msgbox({
    tip: '请确认是否删除这个固件？',
    thenFn: () => toDelete(data),
  })
}

const toDelete = async ({ id }: any) => {
  const res: any = await deleteFirmwareInfo({
    id,
  })
  if (res.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg || '删除成功')
    fetchList()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          onClick: handleForm,
          type: "primary",
          class: "ws_ml16"
        }, {
          default: _withCtx(() => [
            _createTextVNode("添加")
          ]),
          _: 1
        })
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        class: "ws_common_table"
      }, {
        empty: _withCtx(() => [
          _createVNode(_component_el_empty, { description: "暂无数据" })
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(col.value, (item) => {
            return (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({
              key: item.prop
            }, { ...item }, { "show-overflow-tooltip": "" }), null, 16))
          }), 128)),
          _createVNode(_component_el_table_column, { label: "操作" }, {
            default: _withCtx((scope) => [
              _createVNode(_unref(OperationButtonList), {
                scope: scope.row,
                buttonList: buttonList,
                onOnDelete: handleDelete,
                onOnEdit: handleForm
              }, null, 8, ["scope"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, tableLoading.value]
      ]),
      _createVNode(_component_el_pagination, {
        class: "ws_mt50",
        "current-page": pageParams.value.curPage,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((pageParams.value.curPage) = $event)),
        "page-size": pageParams.value.pageSize,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageParams.value.pageSize) = $event)),
        "page-sizes": _unref(PAGE_SIZES),
        layout: "->, total, sizes, prev, pager, next, jumper ",
        total: total.value,
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
    ]),
    _createVNode(FirmwareForm, {
      visible: firmwareConf.value.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((firmwareConf.value.visible) = $event)),
      data: firmwareConf.value.data,
      onOnSuccess: fetchList
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})